// extracted by mini-css-extract-plugin
export default {"message":"CreateStatementModal_message__VwnN3","status":"CreateStatementModal_status__VoZ5s"};